module.exports = __webpack_public_path__ + "static/media/VSS_Final3b.92d4c634.glb";